import { getPlatform } from 'utils/platform'

const WithdrawReasonPageViewed = {
  event: 'screen_viewed',
  object_name: 'laterWithdrawalReason',
  screen: 'laterWithdrawalReason',
  screen_name: 'laterWithdrawalReason',
}

const WithdrawReasonModalViewed = {
  event: 'container_viewed',
  object_name: 'laterWithdrawOverContributedModal',
  screen: 'laterWithdrawalReason',
  screen_name: 'laterWithdrawalReason',
}

const RequestingWithdrawPageViewed = {
  event: 'screen_viewed',
  object_name: 'requestLaterWithdrawal',
  screen: 'requestLaterWithdrawal',
  screen_name: 'requestLaterWithdrawal',
}

const ZeroBalanceModalViewed = {
  event: 'container_viewed',
  object_name: 'accountBalance$0Modal',
  screen: 'requestLaterWithdrawal',
  screen_name: 'accountBalance$0',
}

const WithdrawPageViewed = {
  event: 'screen_viewed',
  object_name: 'laterWithdrawAmountScreen',
  screen: 'laterWithdraw',
  screen_name: 'laterWithdraw',
}

const WithdrawReasonOCModalTapped = {
  event: 'button_tapped',
  object_name: 'laterWithdrawOverContributedModal',
  screen: 'laterWithdrawalReason',
  screen_name: 'laterWithdrawalReason',
  cta_title: 'Got It',
}
const WithdrawReasonEEModalTapped = {
  event: 'button_tapped',
  object_name: 'laterWithdrawalWithExceptionsModalCTA',
  screen: 'laterWithdrawalReason',
  screen_name: 'laterWithdrawalReason',
  cta_title: 'Got It',
}
const WithdrawButtonTapped = (
  portfolioTheme: string,
  portfolioRisk: string,
) => ({
  platform: getPlatform(),
  event: 'button_tapped',
  object_name: 'WithdrawalAmountCTA',
  screen: 'laterWithdraw',
  screen_name: 'laterWithdraw',
  investment_product: 'later',
  cta_title: 'Withdraw',
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
})

const ZeroBalanceModalCancelTapped = {
  event: 'button_tapped',
  object_name: 'accountBalance$0ModalCancel',
  screen: 'requestLaterWithdrawal',
  screen_name: 'requestLaterWithdrawal',
  cta_title: 'Cancel',
}

const OverContributionPageViewed = {
  event: 'screen_viewed',
  object_name: 'laterWithdrawOverContributed',
  screen: 'laterWithdrawOverContributed',
  screen_name: 'laterWithdrawOverContributed',
}

const OverContributionModalViewed = {
  event: 'container_viewed',
  object_name: 'laterWithdrawOverContributedModal',
  screen: 'laterWithdrawOverContributed',
  screen_name: 'laterWithdrawOverContributed',
}
const EEModalViewed = {
  event: 'container_viewed',
  object_name: 'laterWithdrawalWithExceptionsModal',
  screen: 'laterWithdrawalReason',
  screen_name: 'laterWithdrawalReason',
}

const OverContributionModalTapped = (action: string) => ({
  event: 'button_tapped',
  object_name: 'laterWithdrawOverContributedModalCTA',
  screen: 'laterWithdrawOverContributed',
  screen_name: 'laterWithdrawOverContributed',
  cta_title: action,
})

const WithdrawReminderModalViewed = {
  event: 'container_viewed',
  object_name: 'laterWithdrawReminderModal',
  screen: 'laterWithdrawReminderModal',
  screen_name: 'laterWithdrawReminderModal',
}

const WithdrawReminderButtonTapped = (action: string) => ({
  event: 'button_tapped',
  object_name: 'laterWithdrawReminderModal' + action + 'CTA',
  screen: 'laterWithdrawReminderModal',
  screen_name: 'laterWithdrawReminderModal',
  cta_title: action,
})

const WithdrawSuccessfulModalViewed = {
  event: 'container_viewed',
  object_name: 'laterWithdrawConfirmationModal',
  screen: 'laterWithdrawConfirmationModal',
  screen_name: 'laterWithdrawConfirmationModal',
}

const RecurringInvestmentScreenViewed = () => ({
  event: 'screen_viewed',
  object_name: 'laterRecurringInvestments',
  screen: 'laterRecurringInvestments',
  screen_name: 'laterRecurringInvestments',
})

const RecurringInvestmentUpdateButtonTapped = (
  action: string,
  stateChange: boolean,
  amount?: number,
) => ({
  event: 'button_tapped',
  object_name: 'recurringSettingSaved',
  screen: 'laterRecurringInvestment',
  screen_name: 'laterRecurringInvestment',
  amount: `${amount}`,
  cta_title: action,
  state: 'Recurring: on',
  defaultState: 'Reccuring: ' + (stateChange ? 'on' : 'off'),
})

const StopRecurringInvestmentButtonTapped = (amount: number) => ({
  event: 'button_tapped',
  object_name: 'recurringSettingSaved',
  screen: 'laterRecurringInvestment',
  screen_name: 'laterRecurringInvestment',
  cta_title: 'Stop Recurring',
  state: 'Recurring: off',
  defaultState: 'Recurring: on',
  amount,
})

const WithdrawReasonCloseAccountFlowPageViewed = {
  Feature: 'Close Account: Later Withdraw',
  event: 'screen_viewed',
  object_name: 'laterWithdrawal',
  screen: 'laterWithdrawal',
  screen_name: 'laterWithdrawal',
  source: 'closeAccountLater',
}

const WithdrawalAmountLaterViewed = (
  portfolioTheme: string,
  portfolioRisk: string,
) => ({
  platform: getPlatform(),
  object: 'Screen',
  action: 'Viewed',
  object_name: 'WithdrawalAmount',
  screen: 'WithdrawalAmount',
  screen_name: 'WithdrawalAmount',
  investment_product: 'later',
  Withdrawal_amount: '$0',
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
})

const LaterRecurringCtaTapped = {
  event: 'button_tapped',
  object_name: 'laterRecurringCta',
  screen: 'LaterRecurring',
  screen_name: 'LaterRecurring',
}

export {
  WithdrawButtonTapped,
  RequestingWithdrawPageViewed,
  WithdrawReasonPageViewed,
  WithdrawPageViewed,
  ZeroBalanceModalViewed,
  ZeroBalanceModalCancelTapped,
  WithdrawReasonOCModalTapped,
  WithdrawReasonEEModalTapped,
  WithdrawReasonModalViewed,
  EEModalViewed,
  OverContributionPageViewed,
  OverContributionModalViewed,
  OverContributionModalTapped,
  WithdrawReminderModalViewed,
  WithdrawSuccessfulModalViewed,
  WithdrawReminderButtonTapped,
  RecurringInvestmentUpdateButtonTapped,
  StopRecurringInvestmentButtonTapped,
  RecurringInvestmentScreenViewed,
  WithdrawReasonCloseAccountFlowPageViewed,
  WithdrawalAmountLaterViewed,
  LaterRecurringCtaTapped,
}
